import { DesignVersionProvider, ParticleDesignVersions, Tooltip } from 'mage-deps/@klarna/bubble-ui'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import React, { useEffect } from 'react'

import withToggleProps from './withToggleProps'

const DelayedTooltip = ({ show, arrow, delay, onToggle, setTimeout, clearTimeout, children }) => {
  useEffect(() => {
    if (!show) {
      const timeoutId = setTimeout(onToggle, delay)
      return () => {
        clearTimeout(timeoutId)
      }
    }
  }, [show])

  return show
    ? (
      <DesignVersionProvider value={ParticleDesignVersions.NEXT}>
        <Tooltip arrow={arrow}>
          {children}
        </Tooltip>
      </DesignVersionProvider>
    )
    : null
}

DelayedTooltip.propTypes = {
  delay: PropTypes.number,
  arrow: PropTypes.oneOf(['top', 'top-right']),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  show: PropTypes.bool,
  onToggle: PropTypes.func,
  setTimeout: PropTypes.func,
  clearTimeout: PropTypes.func
}

DelayedTooltip.defaultProps = {
  delay: 500,
  show: false,
  arrow: 'top',
  setTimeout: window.setTimeout.bind(window),
  clearTimeout: window.clearTimeout.bind(window)
}

export default R.compose(
  withToggleProps({ show: true })
)(DelayedTooltip)
